import React from 'react';
import {
    Col, Row, Modal, FormControl, FormGroup, ControlLabel, Form
} from 'react-bootstrap';
import Select from 'react-select';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import ModalBlockWrapper from '../Components/ModalBlockWrapper.jsx';

class ModalImport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ownedCalendars: null,
      calendarioSelect: '',
      error: {},
      file: null,
      nombrearchivo: null,
    };

    this.generateOptions = this.generateOptions.bind(this);
    this.checkErrors = this.checkErrors.bind(this);
    this.clearError = this.clearError.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
  }

  componentWillMount() {
    this.props.calendarServices.getOwnCalendars()
      .then(res => {
        this.setState({ownedCalendars: res.calendarios});
      })
      .catch(err =>
        this.props.errorAlert(
          <div>
            Ocurrio un error al cargar los datos de los calendarios, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>)
      );
  }

  handleFileChange(e) {
    e.preventDefault();
    this.setState({ file: this.uploadInput.files[0], nombrearchivo: this.uploadInput.files[0].name });
    this.clearError('file');
  }

  generateOptions() {
    const options = this.state.ownedCalendars.map((item) => {
      return {value: item.id, label: item.nombre};
    });
    return options;
  }

  clearError(key) {
    const auxError = this.state.error;
    auxError[key] = false;
    this.setState({error: auxError});
  }

  checkErrors(data) {
    const auxError = this.state.error;
    let error = false;
    Object.keys(data).forEach((key) => {
      if (!data[key] || data[key] === '') {
        auxError[key] = true;
        error = true;
      }
    });
    this.setState({error: auxError});
    return error;
  }

  importCalendar() {
    const id = this.state.calendarioSelect || this.state.calendarioSelect === '' ? this.state.calendarioSelect.value : null;
    const data = {
      id,
      file: this.state.file,
    }

    const error = this.checkErrors(data);

    if (!error) {
      this.props.importCalendar(data);
    } else {
      this.props.errorAlert(
        <div>
          Uno o mas campos requeridos no han sido completados!
        </div>);
    }
  }

  render() {
    return (
      <Modal show onHide={() => this.props.closeModal()} style={{ display: "block" }}>
        <ModalBlockWrapper
          content={
            <div>
              <Modal.Header closeButton>
                <Modal.Title>Importar Calendario</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!this.state.ownedCalendars ?
                  <Row>
                    <Col md={12}>
                    </Col>
                  </Row> :
                  <Row>
                    <Col md={12}>
                      <Form>
                        <FormGroup validationState={this.state.error.id ? 'error': null}>
                          <ControlLabel>{'Calendario'} </ControlLabel>
                          <Select
                            style={{ borderColor: this.state.error.id ? "#e40040" : "#aaa"}}
                            placeholder="Seleccione Calendario"
                            name="usersCalendar"
                            value={this.state.calendarioSelect}
                            options={this.generateOptions()}
                            onChange={(item) => this.setState({calendarioSelect: item}, this.clearError('id'))}
                          />
                        </FormGroup>
                      </Form>
                    </Col>
                    <Col md={12}>
                      <FormGroup validationState={this.state.error.file ? 'error': null}>
                        <ControlLabel>{'Archivo'} </ControlLabel>
                        <FormControl
                          type="text" value={this.state.nombrearchivo ? this.state.nombrearchivo : 'No se seleccionó ningún archivo..'}
                          disabled
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <span style={{ float: 'left' }}>
                        <input ref={(ref) => { this.uploadInput = ref; }} type="file" style={{'visibility': 'hidden'}} onChange={this.handleFileChange} accept={'ics'} />
                      </span>
                    </Col>
                    <Col md={6}>
                      <span style={{ float: 'right' }}>
                        <Button onClick={() => this.uploadInput.click()} bsStyle="primary" fill={true}>Seleccionar archivo</Button>
                        <Button disabled={!this.state.file || !this.state.nombrearchivo} onClick={() => this.setState({ file: null, nombrearchivo: null })} bsStyle="danger" fill={true}>
                          <i className="fa fa-ban"></i>
                        </Button>
                      </span>
                    </Col>
                  </Row>
                }
              </Modal.Body>
              <Modal.Footer>
                <Button simple onClick={this.props.closeModal}>
                  Cancelar
                </Button>
                <Button
                  bsStyle="success" fill onClick={() => this.importCalendar()}
                >
                  Importar
                </Button>
              </Modal.Footer>
            </div>
          }
        />
      </Modal>
    );
  }
}

export default ModalImport;



// WEBPACK FOOTER //
// ./src/views/Calendar/ModalImport.jsx